module.exports = __webpack_public_path__ + "img/menu_button_playnow_normal@2x.461291c6.png";